import React from 'react'
import PropTypes from 'prop-types'

import KeyFeaturesWrapper from 'agency/digital_renderer/components/KeyFeaturesWrapper'

import styles from './styles.scss'

const KeyFeatures = (props) => {
  const { campaign } = props

  return (
    <KeyFeaturesWrapper
      campaign={campaign}
      render={({ features }) => (
        <ul className={styles.root}>
          {features.map(feature => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
      )}
    />
  )
}

KeyFeatures.propTypes = {
  campaign: PropTypes.object.isRequired,
}

export default KeyFeatures
